import PropTypes from 'prop-types';
import React from 'react';

import NavigationTopBar from './NavigationTopBar';
import NavigationSideBar from './NavigationSideBar';

export default class RouterLayout extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired, // this is passed from the Rails view
  };

  /**
   * @param props - Comes from your rails view.
   */
  constructor(props) {
    super(props);

    let isShowSideBar = true;
    if (props.location && props.location.pathname == "/")
      isShowSideBar = false

    this.state = {
      isShowSideBar: isShowSideBar
    };
  }

  componentWillReceiveProps(newProps) {
    let isShowSideBar = !(newProps.location && newProps.location.pathname == "/")
    this.setState({
      isShowSideBar: isShowSideBar
    });
  }

  _lowerContainerView() {
    if (!this.state.isShowSideBar)
      // before select class
      return (
        <div className="web-pc-app-lower-container">
          {this.props.children && React.cloneElement(this.props.children, {})}
        </div>
      );
    else
      // after select class
      return (
        <div className="web-pc-app-lower-container">
          <NavigationSideBar />
          <div className="main-content">
            {this.props.children && React.cloneElement(this.props.children, {})}
          </div>
        </div>
      );
  }

  render() {
    return (
      <div className="web-pc-app-container">
        <NavigationTopBar  {...this.state} />
        {this._lowerContainerView()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/RouterLayout.jsx